import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User
}

function Owner({ user }: Props) {
  const fullName = user.fullName()
  const dummyValue = 'owner'
  const option = [
    {
      label: i18n.t('custom_reports.share.modal.owner'),
      value: dummyValue,
    },
  ]

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="flexStart">
      <UserAvatar user={user} size="s32" />
      <Box minWidth="none" paddingLeft="s8" paddingRight="s16" flexGrow>
        <Text size="300" weight="medium" color="grey1000" ellipsis>
          {fullName}
        </Text>
      </Box>
      <Box width="s140" flexGrow={false} flexNoShrink maxWidth="s140">
        <SelectField options={option} value={dummyValue} readonly />
      </Box>
    </Box>
  )
}

export default observer(Owner)
